import React from 'react';
import CompSystemHealth from '../Components/CompSystemHealth';

function PageSystemHealth() {
    return (
        <div>
            <CompSystemHealth />
        </div>
    )
}

export default PageSystemHealth